"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clinicalWorkflowExtrasShape = exports.clinicalNotificationRequestSchema = exports.clinicalCallOptionsSchema = void 0;
/**
 * Shared request sub-schemas reused across every Clinical endpoint
 * contract — `clinicalCallOptionsSchema` mirrors backend's
 * `ApplicationCallOptions` (`src/modules/clinical/application/
 * _shared-application/application-call-options.type.ts`, frozen,
 * Stage 6C.3 — itself a type alias of Stage 6C.2's own
 * `DomainCallOptions`) and `clinicalNotificationRequestSchema` mirrors
 * `@core/notification`'s `NotificationRequest`. Both are re-declared
 * here rather than imported from Financial's or Appointment's own
 * `*-common.request.ts` (each independently declares the identical
 * `NotificationRequest` shape) — this package does not share wire
 * shapes across bounded contexts, each re-declares its own, kept in
 * lockstep by convention (`CLINICAL-CONTRACT-REUSE.md` §5).
 */
const zod_1 = require("zod");
exports.clinicalCallOptionsSchema = zod_1.z.object({
    actorUserId: zod_1.z.string().uuid().optional(),
    reason: zod_1.z.string().optional(),
});
exports.clinicalNotificationRequestSchema = zod_1.z.object({
    channel: zod_1.z.enum(['email', 'sms', 'whatsapp']),
    to: zod_1.z.string(),
    subject: zod_1.z.string().optional(),
    body: zod_1.z.string(),
});
/** Every mutating Clinical endpoint accepts these two optional envelopes alongside its own fields — declared once, spread into each endpoint's own schema via `.extend()`/object-spread. */
exports.clinicalWorkflowExtrasShape = {
    options: exports.clinicalCallOptionsSchema.optional(),
    notification: exports.clinicalNotificationRequestSchema.optional(),
};
//# sourceMappingURL=clinical-common.request.js.map